import VerifyEmailSuccessContainer from "../containers/VerifyEmailSuccessContainer";

const VerifyEmailSuccessPage = () => {
  return <VerifyEmailSuccessContainer />;
};

export default VerifyEmailSuccessPage;
